import { Severity } from '@/types/validation';
import { Dangerous, DangerousOutlined, Info, InfoOutlined, Warning, WarningAmberOutlined } from '@mui/icons-material';
import { Box, Icon, SvgIconProps, SxProps, Tooltip } from '@mui/material';
import { FC } from 'react';

type ErrorIconProps = SvgIconProps & {
  severity: Severity;
  colorize?: boolean;
  outlined?: string;
  tooltip?: string;
  tooltipSx?: SxProps;
};

const ErrorIcon: FC<ErrorIconProps> = (props) => {
  const getIcon = () => {
    switch (props.severity) {
      case 'error':
        return props.outlined ? DangerousOutlined : Dangerous;

      case 'warning':
        return props.outlined ? WarningAmberOutlined : Warning;

      default:
        return props.outlined ? InfoOutlined : Info;
    }
  };

  const ColoredIcon: FC<ErrorIconProps> = (props) => (
    <Icon component={getIcon()} {...(props.colorize?.toString() && { color: props.severity })} {...props} />
  );

  return props.tooltip ? (
    <Tooltip title={props.tooltip} placement='right-start' arrow sx={props.tooltipSx}>
      <Box sx={props.sx}>
        <ColoredIcon {...props} />
      </Box>
    </Tooltip>
  ) : (
    <ColoredIcon {...props} />
  );
};

export default ErrorIcon;
